import Rest from '../Rest'

export default class LegalEntityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/legal_entities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  findIncompleteLegalEntity(mediaId: Number) {
    return this.get(`/find_incomplete_legal_entity`).then(data => {
      return data
    })
  }

  updatePrivacyDescription(legalEntityId: Number, data: any) {
    return this.post(`/update_privacy_description/${legalEntityId}`, data).then(data => {
      return data
    })
  }

  importLegalEntities(data: any) {
    return this.post(`/import_legal_entities`, data).then(data => {
      return data
    })
  }

  importLegalEntityUnit(legalEntityId: Number, data: any) {
    return this.post(`/${legalEntityId}/import_legal_entity_unit`, data).then(data => {
      return data
    })
  }
}
